import { useEffect, useState } from "react";
import { SlideUpModal } from "src/components/SlideUpModal";

const default_title =
  "Are you sure you want to start a new application instead of editing your current one?";
const default_action = "Edit current app";
const default_dismiss = "Start new app";

const copy_confirm_title =
  "Do you want to copy your info from your last submission, or start fresh?";
const copy_confirm_action = "Copy";
const copy_confirm_dismiss = "Start fresh app";

type ConfirmDiscardApplicationModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
  confirmEditApp: () => void;
  confirmCloneApp: () => Promise<void>;
  confirmStartNewApp: () => void;
  shouldSkipEditPrompt: boolean;
};

export default ({
  isOpen,
  closeHandler,
  confirmEditApp,
  confirmCloneApp,
  confirmStartNewApp,
  shouldSkipEditPrompt,
}: ConfirmDiscardApplicationModalProps) => {
  const [confirmationStep, setConfirmationStep] = useState<0 | 1>(
    shouldSkipEditPrompt ? 1 : 0,
  );

  useEffect(() => {
    setConfirmationStep(shouldSkipEditPrompt ? 1 : 0);
  }, [shouldSkipEditPrompt]);

  const handleConfirm = () => {
    if (confirmationStep === 0) {
      confirmEditApp();
    } else {
      void confirmCloneApp();
    }
  };
  const handleClose = () => {
    closeHandler();
    setConfirmationStep(0);
  };
  const handleDismiss = () => {
    if (confirmationStep === 0) {
      setConfirmationStep(1);
    } else {
      confirmStartNewApp();
    }
  };

  const titleText = confirmationStep === 0 ? default_title : copy_confirm_title;
  const actionText =
    confirmationStep === 0 ? default_action : copy_confirm_action;
  const dismissText =
    confirmationStep === 0 ? default_dismiss : copy_confirm_dismiss;

  return (
    <SlideUpModal
      title={titleText}
      isOpen={isOpen}
      closeHandler={handleClose}
      dismissHandler={handleDismiss}
      hasDismissButton={true}
      actionButtonText={actionText}
      dismissButtonText={dismissText}
      actionButtonClickHandler={handleConfirm}
    />
  );
};
